import { BaseEntity, Column, Entity, PrimaryColumn } from 'typeorm';

export abstract class GenericModel extends BaseEntity {

  @PrimaryColumn()
  id: number;

  @Column({nullable: true})
  created_at: string;

  @Column({nullable: true})
  updated_at: string;
}
